module.exports = __webpack_public_path__ + "static/media/category-banner.2848c759.jpg";